import { computed } from "@ember/object";
import { classNames } from "@ember-decorators/component";
import ComboBoxComponent from "discourse/select-kit/components/combo-box";
import {
  pluginApiIdentifiers,
  selectKitOptions,
} from "discourse/select-kit/components/select-kit";
import FlairRow from "./flair-row.gjs";
import SelectedFlair from "./selected-flair.gjs";

@classNames("flair-chooser")
@selectKitOptions({
  selectedNameComponent: SelectedFlair,
})
@pluginApiIdentifiers(["flair-chooser"])
export default class FlairChooser extends ComboBoxComponent {
  @computed("value", "content.[]", "selectKit.noneItem")
  get selectedContent() {
    const content = (this.content || []).find(
      (value) => value[this.selectKit.valueProperty] === this.value
    );

    if (content) {
      return this.selectKit.modifySelection(content);
    } else {
      return this.selectKit.noneItem;
    }
  }

  modifyComponentForRow() {
    return FlairRow;
  }
}
